import React, { useState } from 'react';
import { Card, Form, Input, Button, Typography, message, Row, Col } from 'antd';
import { MailOutlined, LockOutlined } from '@ant-design/icons';
import { useAuth } from '../context/AuthContext';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios'; // Import axios directly

const { Title } = Typography;
// The public API endpoint for authentication doesn't live under /api/v1
// const AUTH_URL = 'http://localhost:8888/api/auth/login';
const AUTH_URL = 'https://erp-api.caojie666.xyz/api/auth/login';

const Login = () => {
  const [loading, setLoading] = useState(false);
  const auth = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const from = location.state?.from?.pathname || '/';

  const onFinish = async (values) => {
    setLoading(true);
    try {
      // Call the public login endpoint directly, bypassing the default api instance
      const { data } = await axios.post(AUTH_URL, {
        email: values.email,
        password: values.password,
      });

      if (data.session) {
        auth.login(data.session); // Pass the session to AuthContext
        navigate(from, { replace: true });
      } else {
        message.error('登录失败，返回数据格式不正确。');
      }

    } catch (error) {
      const errorMsg = error.response?.data?.error || '登录失败，请检查您的凭据。';
      message.error(errorMsg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Row justify="center" align="middle" style={{ minHeight: '100vh', background: '#f0f2f5' }}>
      <Col xs={22} sm={16} md={12} lg={8} xl={6}>
        <Card>
          <div style={{ textAlign: 'center', marginBottom: '24px' }}>
            <Title level={2}>ERP 系统登录</Title>
          </div>
          <Form
            name="login_form"
            initialValues={{ remember: true }}
            onFinish={onFinish}
          >
            <Form.Item
              name="email"
              rules={[{ required: true, message: '请输入您的邮箱!' }, { type: 'email', message: '请输入有效的邮箱地址!' }]}
            >
              <Input prefix={<MailOutlined />} placeholder="邮箱" />
            </Form.Item>
            <Form.Item
              name="password"
              rules={[{ required: true, message: '请输入您的密码!' }]}
            >
              <Input.Password prefix={<LockOutlined />} placeholder="密码" />
            </Form.Item>
            
            <Form.Item>
              <Button type="primary" htmlType="submit" loading={loading} style={{ width: '100%' }}>
                登录
              </Button>
            </Form.Item>
          </Form>
        </Card>
      </Col>
    </Row>
  );
};

export default Login;
